import * as React from 'react';
import classnames from 'classnames';
import { dataTestid } from '../../../constants/dataTestid';

interface IToggleProps {
    label?: string;
    checked: boolean;
    className?: string;
    onChange: (value) => void;
    disabled?: boolean;
    position?: 'left' | 'right';
}

const Toggle: React.SFC<IToggleProps> = (props) => {
    const { label, checked, className, disabled, position, ...attr } = props;
    return (
        <>
            {(!position || position === 'left') && (
                <label className="switch--label">{label || ''}</label>
            )}
            <label
                className={classnames('switch', {
                    [className]: !!className,
                    disabled: disabled
                })}
            >
                <input
                    type="checkbox"
                    checked={checked}
                    {...attr}
                    onChange={(event) => {
                        props.onChange(event.target.checked);
                    }}
                    disabled={disabled}
                />
                <span className="slider round" data-test={dataTestid.SLIDER}>
                    <span></span>
                </span>
            </label>
            {position === 'right' && (
                <label className="switch--label">{label || ''}</label>
            )}
        </>
    );
};

export default Toggle;
